import { render, staticRenderFns } from "./VDesigningBarTools.vue?vue&type=template&id=8307b3dc&"
import script from "./VDesigningBarTools.vue?vue&type=script&lang=ts&"
export * from "./VDesigningBarTools.vue?vue&type=script&lang=ts&"
import style0 from "./VDesigningBarTools.vue?vue&type=style&index=0&id=8307b3dc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports